import { Hotkey } from "../../../../../ui/hotkey/component.js";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
//#region src/internal/skins/shared/skins/shared/playback-hotkeys.tsx
/** @jsxImportSource react */
function PlaybackHotkeys({ disabled = false } = {}) {
	return /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx(Hotkey, {
			disabled,
			keys: "Space",
			action: "togglePaused"
		}),
		/* @__PURE__ */ jsx(Hotkey, {
			disabled,
			keys: "k",
			action: "togglePaused"
		}),
		/* @__PURE__ */ jsx(Hotkey, {
			disabled,
			keys: "m",
			action: "toggleMuted"
		}),
		/* @__PURE__ */ jsx(Hotkey, {
			disabled,
			keys: "ArrowRight",
			action: "seekStep"
		}),
		/* @__PURE__ */ jsx(Hotkey, {
			disabled,
			keys: "ArrowLeft",
			action: "seekStep"
		}),
		/* @__PURE__ */ jsx(Hotkey, {
			disabled,
			keys: "l",
			action: "seekStep"
		}),
		/* @__PURE__ */ jsx(Hotkey, {
			disabled,
			keys: "j",
			action: "seekStep"
		}),
		/* @__PURE__ */ jsx(Hotkey, {
			disabled,
			keys: "ArrowUp",
			action: "volumeStep"
		}),
		/* @__PURE__ */ jsx(Hotkey, {
			disabled,
			keys: "ArrowDown",
			action: "volumeStep"
		}),
		/* @__PURE__ */ jsx(Hotkey, {
			disabled,
			keys: "0-9",
			action: "seekToPercent"
		}),
		/* @__PURE__ */ jsx(Hotkey, {
			disabled,
			keys: "Home",
			action: "seekToPercent",
			value: 0
		}),
		/* @__PURE__ */ jsx(Hotkey, {
			disabled,
			keys: "End",
			action: "seekToPercent",
			value: 100
		}),
		/* @__PURE__ */ jsx(Hotkey, {
			disabled,
			keys: ">",
			action: "speedUp"
		}),
		/* @__PURE__ */ jsx(Hotkey, {
			disabled,
			keys: "<",
			action: "speedDown"
		})
	] });
}
//#endregion
export { PlaybackHotkeys };

//# sourceMappingURL=playback-hotkeys.js.map